module.exports = function (app) {
  var contacts = app.keychain.returnKeys().filter(function (key) {
    return !['group', 'event', 'scheduled_call'].includes(key === null || key === void 0 ? void 0 : key.type);
  });
  if (!contacts.length) {
    return '<div class="settings-appspace-contacts-empty">No contacts in your keyring.</div>';
  }
  return contacts.map(function (contact) {
    var publicKey = app.browser.escapeHTML(contact.publicKey);
    var name = app.keychain.returnIdentifierByPublicKey(contact.publicKey, true);
    if (name === contact.publicKey) {
      name = 'Anonymous User';
    }
    return "\n        <div class=\"settings-appspace-contact\" data-id=\"".concat(publicKey, "\" role=\"button\" tabindex=\"0\">\n          <div class=\"saito-identicon-box\">\n            <img class=\"saito-identicon\" src=\"").concat(app.keychain.returnIdenticon(contact.publicKey), "\" alt=\"\">\n          </div>\n          <div class=\"settings-appspace-contact-details\">\n            <div class=\"settings-appspace-contact-name\">").concat(app.browser.escapeHTML(name), "</div>\n            <div class=\"settings-appspace-contact-key\" title=\"").concat(publicKey, "\">").concat(publicKey, "</div>\n          </div>\n        </div>");
  }).join('');
};